"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StripeIdentityBanner = void 0;
var StripeIdentityBanner_1 = __importDefault(require("./StripeIdentityBanner"));
exports.StripeIdentityBanner = StripeIdentityBanner_1.default;